var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "attachment",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 15,
    viewBox: "0 0 27 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "attachment-1",
    d: "M0,7.25 C0,3.24272727 3.2595,0 7.2875,0 L21.2,0 C24.12825,0 26.5,2.35954545 26.5,5.27272727 C26.5,8.18590909 24.12825,10.5 21.2,10.5 L9.9375,10.5 C8.109,10.5 6.625,9.06909091 6.625,7.25 C6.625,5.43090909 8.109,4 9.9375,4 L19.5,4 L19.5,6.5 L9.81825,6.5 C8.75,6.5 8.75,8 9.81825,8 L21.2,8 C22.6575,8 23.85,6.72272727 23.85,5.27272727 C23.85,3.82272727 22.6575,2.5 21.2,2.5 L7.2875,2.5 C4.73025,2.5 2.65,4.70590909 2.65,7.25 C2.65,9.79409091 4.73025,12 7.2875,12 L19.5,12 L19.5,14.5 L7.2875,14.5 C3.2595,14.5 0,11.2572727 0,7.25 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attachment-2",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "attachment-3",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    id: "attachment-4",
    xlinkHref: "#attachment-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "attachment-5",
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#attachment-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "attachment-6",
    fill: "#151515",
    mask: "url(#attachment-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "attachment-7",
    width: 32,
    height: 32,
    transform: "translate(-3 -9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.f2ad426b7d85d219652c244c540a9895.svg";
export { ForwardRef as ReactComponent };